<template>
  <div class="vilDuVaelge">
    <h1>{{ $t('vaelgVaerelse') }}</h1>

    <!-- Vis 'loading' ikon mens API data loader... -->
    <img v-if="this.$store.getters.loading === true" src="@/assets/loading.svg" alt="">

<div>
  <!-- Roomtype: {{this.$store.getters.bookingInProgress.roomtype}} -->
  <!-- OrderedRoomsCopy: {{ this.orderedRoomsCopy }} -->
</div>

<div class="missingContainer" v-if="doneChoosing(this.orderedRoomsCopy) > 0">
  <ul class="vaerelser-der-skal-vaelges">
    <p>{{ $t('dumangleratvaelge') }}:</p>
    <li v-for="(no, room) in this.orderedRoomsCopy" v-bind:key=room>
      {{no}}<span style="text-transform: lowercase;">x</span> {{ $t(room)}}
    </li>
  </ul>
</div>

<div v-else style:="display:none;">
  <ul class="vaerelser-der-skal-vaelges">
    <p>&nbsp;</p>
    <li v-for="(no, room) in this.orderedRooms" v-bind:key=room>
      &nbsp;
    </li>
  </ul>
</div>

<div class="roomDisplay">
  <!-- Loop igennem de ledige værelser - hvis et rum er valgt, sæt anden baggrund for den <div> -->
  <div v-for="room in this.$store.getters.availableRooms" v-bind:key="room.id_room" v-bind:style="[wantsContains(room.id_room) ? {'filter': 'opacity(25%)'} : {}]">
  <!-- Gør hver box clickable og toggle det rum der klikkes på -->
  <span v-on:click="toggleRoom(room.id_room, room.short_code)">

    <div v-if="$store.getters.bookingInProgress.roomtype == 'parkering'" class="roomBox room-4">
      <p style="font-size:200%; margin-top: -80px; margin-bottom: -80px;">{{ $t('pplads') }}</p>
      <p style="font-size:500%;">{{room.short_desc}}</p>
      <p style="font-size:200%; margin-top: -80px;">{{ $t(room.short_code)}}</p>
    </div>

    <div v-else class="roomBox" :class="['room-'+room.short_code]">
      <p v-if="$store.getters.bookingInProgress.roomtype == 'parkering'" class="vaerelsesNoText">{{ $t('pplads') }}</p>
      <p v-else class="vaerelsesNoText">{{ $t('vaerelsenr') }} </p>
      <p class="short_desc">{{room.short_desc}}</p>
      <p class="short_code">{{ $t(room.short_code)}}</p>
    </div>

  </span>
  </div>
</div>


<div>
  <img v-if="this.$store.getters.bookingInProgress.hotel == 2770" src="https://bookingapi2.bbhotels.dk/storage/plantegning-kastrup-1.jpg" alt="Plantegning">
  <img v-if="this.$store.getters.bookingInProgress.hotel == 2770" src="https://bookingapi2.bbhotels.dk/storage/plantegning-kastrup-2.jpg" alt="Plantegning">
  <img v-if="this.$store.getters.bookingInProgress.hotel == 3700" src="https://bookingapi2.bbhotels.dk/storage/plantegning-roenne.jpg" alt="Plantegning">
  <img v-if="this.$store.getters.bookingInProgress.hotel == 7100" src="https://bookingapi2.bbhotels.dk/storage/plantegning-vejle-1.jpg" alt="Plantegning">
  <img v-if="this.$store.getters.bookingInProgress.hotel == 7100" src="https://bookingapi2.bbhotels.dk/storage/plantegning-vejle-2.jpg" alt="Plantegning">
  <img v-if="this.$store.getters.bookingInProgress.hotel == 7400" src="https://bookingapi2.bbhotels.dk/storage/plantegning-herning.jpg" alt="Plantegning">
  <img v-if="this.$store.getters.bookingInProgress.hotel == 8000" src="https://bookingapi2.bbhotels.dk/storage/plantegning-aarhus.jpg" alt="Plantegning">
  <img v-if="this.$store.getters.bookingInProgress.hotel == 9900" src="https://bookingapi2.bbhotels.dk/storage/plantegning-frederikshavn-1.jpg" alt="Plantegning">
  <img v-if="this.$store.getters.bookingInProgress.hotel == 9900" src="https://bookingapi2.bbhotels.dk/storage/plantegning-frederikshavn-2.jpg" alt="Plantegning">
  
  <!-- På kundehotellerne navngives plantegningerne 'plantegning-koncern-postnr.jpg' - findes ingen plantegning indsættes 1x1 transparent PNG -->
  <img v-bind:src="'https://api.kunder.bbsystems.dk/storage/plantegning-'+this.$route.params.koncern+'-'+this.$store.getters.bookingInProgress.hotel+'.jpg'" alt="Plantegning" @error="defaultImage">
</div>

<!-- Vis kun 'videre' knap hvis alle værelser er valgt -->
<!-- <router-link to="ekstra" v-if="doneChoosing(this.orderedRoomsCopy) <= 0">
  <div class="continueButton" >
    <a>{{ $t('videre') }}</a>
  </div>
</router-link>
  
<div v-else class="continueButton" style="opacity: 0.2;">
  <a>{{ $t('videre') }}</a>
</div> -->

<!-- 
  <div class="buttonContainer">
    <router-link to="vilDuVaelge">
      <div class="continueButton">
          <a>&laquo; {{$t('tilbage')}} </a>
      </div>
    </router-link>

    <router-link to="ekstra" v-if="doneChoosing(this.orderedRoomsCopy) <= 0">
      <div class="continueButton">
          <a>{{ $t('videre') }} &raquo;</a>
      </div>
    </router-link>
    <a v-else>
      <div class="continueButton" style="opacity: 0.2;">
        <a>{{ $t('videre') }} &raquo;</a>
      </div>
    </a>
  </div>
 -->

    <router-link to="vilDuVaelge">
      <div class="tilbage">
          <p>&#171; {{$t('tilbagetekst')}}</p>
      </div>
    </router-link>


<!-- <plantegning @chosenRooms="handleChosenRooms">
</plantegning>
 -->

<!-- <svg
   xmlns="http://www.w3.org/2000/svg"
   xmlns:xlink="http://www.w3.org/1999/xlink"
   viewBox="0 0 1365.3333 580"
   height="580"
   width="1365.3333"
   id="svg102"
   version="1.1">
  <metadata
     id="metadata108">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
  <defs
     id="defs106" />
  <image
     :xlink:href="require(`@/assets/plantegning-${this.$store.getters.bookingInProgress.hotel}.png`)"
     width="1365.3333"
     height="580"
     preserveAspectRatio="none"
     id="image110"
     x="0"
     y="0" />
  <rect
     v-on:click="toggleRoom('r20')"
     x="121.97501"
     y="13.406374"
     height="130.82805"
     width="88.530251"
     id="20"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="20">20</title>
  </rect>
    <g transform="translate(121.97501,13.406374)"><g transform="translate(20,10)">
      <path
        v-on:click="toggleRoom('r20')"
        style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
        id="r20"
        d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
    </g></g>
  <rect
     v-on:click="toggleRoom('r21')"
     x="210.50526"
     y="13.406374"
     height="128.8607"
     width="99.350624"
     id="21"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="21">21
    </title>
  </rect>
    <g transform="translate(210.50526,13.406374)"><g transform="translate(20,10)">
      <path
        v-on:click="toggleRoom('r21')"
        style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
        id="r21"
        d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
    </g></g>
  <rect
     v-on:click="toggleRoom('r22')"
     x="309.8559"
     y="13.406374"
     height="130.82805"
     width="98.366943"
     id="22"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="22">22</title>
  </rect>
      <g transform="translate(309.8559,13.406374)"><g transform="translate(20,10)">
      <path
        v-on:click="toggleRoom('r22')"
        style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
        id="r22"
        d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
    </g></g>
  <rect
     v-on:click="toggleRoom('r23')"
     x="408.22284"
     y="13.406374"
     height="132.79538"
     width="98.366951"
     id="23"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="23">23</title>
  </rect>
  <g transform="translate(408.22284,13.406374)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r23')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r23"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r24')"
     x="506.58978"
     y="13.406374"
     height="132.79538"
     width="96.399612"
     id="24"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="24">24</title>
  </rect>
    <g transform="translate(506.58978,13.406374)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r24')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r24"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
      </g></g>
  <rect
     v-on:click="toggleRoom('r25')"
     x="602.98938"
     y="13.406374"
     height="131.81171"
     width="107.21999"
     id="25"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="25">25</title>
  </rect>
    <g transform="translate(602.98938,13.406374)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r25')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r25"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
    </g></g>

  <rect
    v-on:click="toggleRoom('r27')"
     x="710.20935"
     y="13.406374"
     height="131.81171"
     width="103.28534"
     id="27"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="27">27</title>
  </rect>
      <g transform="translate(710.20935,13.406374)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r27')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r27"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
      </g></g>

  <rect
     v-on:click="toggleRoom('r28')"
     x="813.49469"
     y="13.406374"
     height="133.77905"
     width="106.23628"
     id="28"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="28">28</title>
  </rect>
    <g transform="translate(813.49469,13.406374)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r28')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r28"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
      </g></g>

  <rect
     v-on:click="toggleRoom('r29')"
     x="919.73096"
     y="13.406374"
     height="132.79538"
     width="108.20366"
     id="29"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="29">29</title>
  </rect>
  <g transform="translate(919.73096,13.406374)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r29')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r29"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r30')"
     x="1027.9346"
     y="13.406374"
     height="131.81171"
     width="106.23635"
     id="30"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="30">30</title>
  </rect>
  <g transform="translate(1027.9346,13.406374)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r30')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r30"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r31')"
     x="1134.1709"
     y="13.406374"
     height="133.77905"
     width="109.18734"
     id="31"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="31">31</title>
  </rect>
  <g transform="translate(1134.1709,13.406374)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r31')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r31"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r32')"
     x="1243.3583"
     y="13.406374"
     height="131.81171"
     width="106.23627"
     id="32"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="32">32</title>
  </rect>
  <g transform="translate(1243.3583,13.406374)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r32')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r32"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r45')"
     x="123.94235"
     y="213.09128"
     height="159.35446"
     width="160.33812"
     id="45"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="45">45</title>
  </rect>
  <g transform="translate(123.94235,213.09128)"><g transform="translate(50,20)">
    <path
      v-on:click="toggleRoom('r45')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r45"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>


  <rect
     v-on:click="toggleRoom('r46')"
     x="284.28046"
     y="213.09128"
     height="162.30547"
     width="171.15852"
     id="46"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="46">46</title>
  </rect>
  <g transform="translate(284.28046,213.09128)"><g transform="translate(50,20)">
    <path
      v-on:click="toggleRoom('r46')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r46"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>


  <rect
     v-on:click="toggleRoom('r47')"
     x="455.43896"
     y="213.09128"
     height="158.37079"
     width="156.40346"
     id="47"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="47">47</title>
  </rect>
  <g transform="translate(455.43896,213.09128)"><g transform="translate(50,20)">
    <path
      v-on:click="toggleRoom('r47')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r47"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r48')"
     x="611.84241"
     y="213.09128"
     height="160.33813"
     width="169.19116"
     id="48"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="48">48</title>
  </rect>
  <g transform="translate(611.84241,213.09128)"><g transform="translate(50,20)">
    <path
      v-on:click="toggleRoom('r48')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r48"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>


  <rect
     v-on:click="toggleRoom('r49')"
     x="781.03357"
     y="213.09128"
     height="159.35446"
     width="192.79922"
     id="49"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="49">49</title>
  </rect>
  <g transform="translate(781.03357,213.09128)"><g transform="translate(50,20)">
    <path
      v-on:click="toggleRoom('r49')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r49"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>


  <rect
     v-on:click="toggleRoom('r50')"
     x="973.83276"
     y="213.09128"
     height="160.33813"
     width="201.65228"
     id="50"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="50">50</title>
  </rect>
  <g transform="translate(973.83276,213.09128)"><g transform="translate(50,20)">
    <path
      v-on:click="toggleRoom('r50')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r50"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>


  <rect
     v-on:click="toggleRoom('r51')"
     x="1175.4851"
     y="213.09128"
     height="160.33813"
     width="176.07677"
     id="51"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="51">51</title>
  </rect>
  <g transform="translate(1175.4851,213.09128)"><g transform="translate(50,20)">
    <path
      v-on:click="toggleRoom('r51')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r51"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>


  <rect
     v-on:click="toggleRoom('r26')"
     x="120.99135"
     y="438.35159"
     height="122.95869"
     width="84.595573"
     id="26"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="26">26</title>
  </rect>
  <g transform="translate(120.99135,438.35159)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r26')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r26"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>


  <rect
     v-on:click="toggleRoom('r33')"
     x="205.58691"
     y="438.35159"
     height="122.95869"
     width="102.30164"
     id="33"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="33">33</title>
  </rect>
  <g transform="translate(205.58691,438.35159)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r33')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r33"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r34')"
     x="307.88855"
     y="438.35159"
     height="123.94236"
     width="107.21998"
     id="34"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="34">34</title>
  </rect>
  <g transform="translate(307.88855,438.35159)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r34')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r34"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r35')"
     x="415.10852"
     y="438.35159"
     height="121.97501"
     width="94.432274"
     id="35"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="35">35</title>
  </rect>
  <g transform="translate(415.10852,438.35159)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r35')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r35"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r36')"
     x="509.5408"
     y="438.35159"
     height="122.95869"
     width="99.350609"
     id="36"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="36">36</title>
  </rect>
  <g transform="translate(509.5408,438.35159)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r36')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r36"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r37')"
     x="608.89142"
     y="438.35159"
     height="123.94236"
     width="106.2363"
     id="37"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="37">37</title>
  </rect>
  <g transform="translate(608.89142,438.35159)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r37')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r37"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r38')"
     x="715.12769"
     y="438.35159"
     height="120.00768"
     width="103.28533"
     id="38"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="38">38</title>
  </rect>
  <g transform="translate(715.12769,438.35159)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r38')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r38"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r39')"
     x="818.41302"
     y="438.35159"
     height="120.99135"
     width="101.31795"
     id="39"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="39">39</title>
  </rect>
  <g transform="translate(818.41302,438.35159)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r39')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r39"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r40')"
     x="919.73096"
     y="438.35159"
     height="122.95869"
     width="81.644585"
     id="40"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="40">40</title>
  </rect>
  <g transform="translate(919.73096,438.35159)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r40')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r40"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r41')"
     x="1001.3755"
     y="438.35159"
     height="122.95869"
     width="92.46492"
     id="41"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="41">41</title>
  </rect>
  <g transform="translate(1001.3755,438.35159)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r41')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r41"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r42')"
     x="1093.8405"
     y="438.35159"
     height="121.97501"
     width="80.660919"
     id="42"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="42">42</title>
  </rect>
  <g transform="translate(1093.8405,438.35159)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r42')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r42"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r43')"
     x="1174.5013"
     y="438.35159"
     height="122.95869"
     width="87.546616"
     id="43"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="43">43</title>
  </rect>
  <g transform="translate(1174.5013,438.35159)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r43')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r43"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

  <rect
     v-on:click="toggleRoom('r44')"
     x="1262.048"
     y="438.35159"
     height="120.99135"
     width="89.513908"
     id="44"
     style="fill:rgba(0,0,0,0.0)">
    <title
       id="44">44</title>
  </rect>
  <g transform="translate(1262.048,438.35159)"><g transform="translate(20,10)">
    <path
      v-on:click="toggleRoom('r44')"
      style="fill:#1d13d1;fill-opacity:1;stroke-width:4.25286293; display: none"
      id="r44"
      d="M 18.528379,91.320926 4.7491094,63.209492 c -4.74789995,-9.686276 0.19137,-7.16628 2.27511,-4.12523 15.1742896,20.377094 10.8282496,28.237394 23.4547096,2.42409 l 25.3343,-51.7930614 c 2.08586,-4.334145 3.64245,-0.02552 1.45448,5.1391554 l -27.59258,72.59637 c -1.62267,4.26929 -7.59561,8.71837 -11.14675,3.82757 l -0.005,0.0213 z" />
  </g></g>

</svg> -->



      <!-- <p>{{$store.getters.availableRooms}}</p> -->


  </div>
</template>

<script>
//import plantegning from '@/views/plantegninger/plantegning.vue'

export default {
  name: 'App',
  data () {
    return {
      item: {"test": 2},
      order: {'D': 1},
      orderedRooms: this.findOrderedRoomsObj(this.$store.getters.bookingInProgress.needs),
      orderedRoomsCopy: {},
      counter: 0,
      chosenRooms: [],
      bookedRooms: [],
    }
  },
  created() {
    this.$store.dispatch("getAvailableRooms", {
      'koncern': this.$route.params.koncern,
      'hotel': this.$store.getters.bookingInProgress.hotel, 
      'start': this.$store.getters.bookingInProgress.startdate, 
      'end': this.$store.getters.bookingInProgress.enddate, 
      'rooms': this.findOrderedRooms(this.$store.getters.bookingInProgress.needs)
    });
  },
  mounted() {
    // Lav en kopi af orderedRooms som vi kan manipulere, uden at miste kundens valg på forrige side
    this.orderedRoomsCopy = JSON.parse(JSON.stringify(this.orderedRooms));  

    // Vi bliver nødt til at nulstille brugerens valg ved page load, da de 'gamle' valg ikke er med i this.orderedRoomsCopy
    var name = 'wants';
    var value = [];
    this.$store.dispatch("addToCart", {name, value});
    //document.addEventListener("backbutton", this.navigatedBack(), false);
  },
  beforeDestroy() {
    document.removeEventListener("backbutton", this.navigatedBack());
  },
  beforeUpdate() {
  },
  components: {
    //plantegning,
  },
  methods: {
    /* Genererer en komma sepereret liste over de værelser der er bestilt (eks: '1,D,3') 
     * tager this.$store.getters.bookingInProgress.needs som argument 
     */
    findOrderedRooms(rooms) {
      var orderedRooms = [];
      for(var key in rooms) {
        if(rooms.hasOwnProperty(key)) {
          if(rooms[key] > 0) {
            orderedRooms.push(key);
          }
        }
      }
    return orderedRooms.join(',');
    },
    /* Genererer et obj med de vaerelsestyper der er valgt samt antal */
    findOrderedRoomsObj(rooms) {
      var orderedRooms = {};
      for(var key in rooms) {
        if(rooms.hasOwnProperty(key)) {
          if(rooms[key] > 0) {
            orderedRooms[key] = rooms[key];
          }
        }
      }
    return orderedRooms;
    },
    navigatedBack() {
      console.log("Bruger har navigeret tilbage...");
    },
    addOrderedRooms(type) {
      if(this.orderedRoomsCopy[type] < this.orderedRooms[type]) {
        this.orderedRoomsCopy[type]++;
      }
    },
    subOrderedRooms(type) {
        this.orderedRoomsCopy[type]--;
    },
    wantsContains(n) {
      return this.$store.getters.bookingInProgress.wants.indexOf(n) > -1
    },
    doneChoosing(orderedRoomsCopy) {
      var left = 0;
      for(var no in orderedRoomsCopy) {
        if(orderedRoomsCopy.hasOwnProperty(no)) {
          if(orderedRoomsCopy[no] > 0) {
            left++;
          }
        }
      }
      return left;
    },

/* toggleRoom() blev brugt til valg efter SVG plantegning - det skal muligvis bruges igen, så den er ikke fjernet */
/*     toggleRoom(id) {
      var style = document.getElementById(id).style.display;
      if(style === "none") {
        document.getElementById(id).style.display = "block";
        this.chosenRooms.push(id);
      } else {
        document.getElementById(id).style.display = "none";
        this.removeFromArr(this.chosenRooms, id);
        console.log("Fjerner :"+id);
      }
     },
*/
    removeFromArr(arr, val) {
      for (var i=0; i < arr.length; i++) {
        if(arr[i] === val) {
          arr.splice(i, 1);
          i--;
        }
      }
    },
    handleChosenRooms(chosenRooms) {
      this.chosenRooms = chosenRooms;
    },
    toggleRoom(room,short_code) {
      var name = 'wants';                                       // Det objekt i 'bookingInProgress' vi vil ændre
      var value = this.$store.getters.bookingInProgress.wants;  // Den værdi der skal sættes i 'bookingInProgress'
      var totalWants = Object.keys(value).length;
      var i;
      var removed = 0;

      // Loop igennem alle wants - hvis 'room' allerede findes i én af dem, skal den fjernes
      // Hvis ikke tilføjer vi 'room' til 'wants'
      for(i=0; i < totalWants; i++) {
        if(value[i] == room) {
          this.removeFromArr(value, room);  // Fjern room hvis den allerede findes
          this.addOrderedRooms(short_code); // Tilføj én til værelser vi mangler at vælge
          removed++;
        }
      }
      if(removed < 1) {
        if(this.orderedRoomsCopy[short_code] > 0) {
          value.push(room);                 // Tilføj valgte room
          this.subOrderedRooms(short_code); // Fjern én fra listen over værelser vi mangler at vælge
        }
      }

      this.$store.dispatch("addToCart", {name, value}); // Send den opdaterede 'wants'-liste til Vuex-store

      // Hvis der ikke er flere værelser at vælge, så navigér til næste side
      if(this.doneChoosing(this.orderedRoomsCopy) <= 0) {
        this.$router.push({path: 'ekstra'});
      }
    },
    // Returnér et default logo (transparent PNG)
    defaultImage(event) {
        event.target.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
    }

  },
}
</script>

<style scoped>
html {
  height: 100%;
}

body {
  height: 100%;
}

h1 {
  font-size: 400%;
  margin-bottom: 80px;
  font-weight: normal;
}

.tilbage {
    text-transform: none;
    color: black;
}

.buttonContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 50px;
}

.continueButton {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 280px;
  height: 80px;  
  font-size: 150%;
  letter-spacing: 1px;
  padding-left: 10px;
  padding-right: 10px;
  margin: 20px;
  white-space: nowrap;
  flex: 0 0 100%;
}

a {
  text-decoration: none;
  color: black;
  text-align: center;
  line-height: 80px;
}

.missingContainer {
  /* position: fixed; */
  position: sticky;
  top: 10px;
  width: 300px;
  margin: auto;
  z-index: 999;
  right: 10px;
  /* top: 120px; */
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
}

.vaerelser-der-skal-vaelges {
  list-style-type: none;
  text-align: left;
}

.roomDisplay {
  padding: 0;
  margin: 0 auto;
  margin-top: 80px;
  list-style: none;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content:center;
  height: 100%;
  max-width: 1200px;
}

.roomBox {
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 330px;
  height: 220px;
  box-sizing: border-box;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 100px;
  margin-top: 0px;
  margin-left: 20px;
  margin-right: 20px;
  cursor: pointer;
}

.vaerelsesNoText {
  font-size: 80%;
  margin-top: -50px;
  margin-bottom: 0px;
}

.short_desc {
  font-size: 5ch;
  margin-top: -0px;
}

.short_code {
  font-size: 2ch;
  margin-top: -30px;
}

:before {
  --url: url("../assets/fireseng-ikon.gif");
}


[class^='room']:before {
  /* content: url("../assets/enkeltseng-ikon.gif"); */
  /* content: url("http://bookingapi.udvikling.bbhotels.dk:81/storage/ikon-1.png"); */
  /* content: url("https://bookingapi2.bbhotels.dk/storage/ikon-1.png"); */
  transform: scale(.5);
  -webkit-transform: scale(.5);
  transform-origin:center;
  margin-top: -150px;
  display: block;
}

.room-1:before {
  /* content: url("../assets/enkeltseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-1.png");
  transform: scale(.5);
  -webkit-transform: scale(.5);
  transform-origin:center;
  
  display: block;
}

.room-2:before {
  /* content: url("../assets/toseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-2.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-D:before {
  /* content: url("../assets/Dobbeltseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-D.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-H:before {
  /* content: url("https://bookingapi2.bbhotels.dk/storage/ikon-D2.png"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-H.png");
  margin-top: -150px;
  display: block;
}

.room-3:before {
  /* content: url("../assets/treseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-3.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-4:before {
  /* content: url("../assets/fireseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-4.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-5:before {
  /* content: url("../assets/fireseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-5.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-6:before {
  /* content: url("../assets/fireseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-6.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-p:before {
  /* content: url("../assets/enkeltseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-P.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-C:before {
  /* content: url("../assets/enkeltseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-C.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-S:before {
  /* content: url("../assets/enkeltseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-S.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}

/* når viewport er mindre end 960 px */
@media (max-width: 959px) {
  /* Mindre overskrift */
  h1 {
    font-size: 200%;
    margin-bottom: 50px;
  }

}

/* Fanger MS-Edge (præ-chrome renderer) specifikt - font-størrelse og margin er forkerte */
@supports (-ms-ime-align: auto) {
  .short_code {
    font-size: 1ch;
  }

  .short_desc {
    font-size: 3ch;
    margin-top: -5px;
    margin-bottom: 40px;
  }


}

</style>
